import Vue from 'vue';
import { GroupOrderPageLoadEvent } from '../../../services/analytics/events';

Vue.directive('track-group-order-page-load', {
  async inserted(el, binding, vnode) {
    const analytics = vnode.context?.$services.analytics;
    analytics?.send(new GroupOrderPageLoadEvent(binding.arg ?? ''));
  },
});
